import React, { Component } from "react";
import { Tab, Tabs } from 'react-bootstrap';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import ActionButton from "../../../../common/button/actionbutton.component.jsx";
import OnlinePayment from '../../../../common/credit-card/online-payment.component.jsx';
import { GlobalHelper } from '../../../../indexImports.js';
import TestModeAlert from '../../../../payment-processing/components/TestModeAlert';
import { PAYMENT_TYPE } from '../../../../state/helpers/Payment';
import { INTEGRATION_KEY } from '../../../../state/integration/Constants';


const messages = defineMessages({
    my_account: {
        id: 'checkout.payment.my_account',
        defaultMessage: 'On Account',
    },
    credit_card_payment: {
        id: 'checkout.payment.credit_card_payment',
        defaultMessage: 'Credit Card',
    },
    bank_transfer_payment: {
        id: 'checkout.payment.bank_transfer_payment',
        defaultMessage: 'Bank Account',
    },
})
class PaymentTypeTabs extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            activeTabKey: this.getActiveKey(props),
        }
    }

    showBankTransferTab() {
        return this.props.paymentMethods.includes("bank-transfer") && this.isRainforestBankTransferEnabled(this.props)
    }

    getActiveKey() {
        if (this.props.variables && this.props.variables.quote.objectType == "credit-memo") {
            return this.props.paymentMethods[0] || "credit-card"
        }
        return "credit-card"
    }

    isRainforestBankTransferEnabled() {
        return this.props.variables.global.paymentIntegrationKey === INTEGRATION_KEY.RAINFOREST &&
            this.props.paymentMethods.includes("bank-transfer") &&
            this.props.variables.global.hasIntegratedPayment &&
            this.props.variables.global.hasIntegratedPaymentBankAccount
    }

    getDisplayPaymentMethods() {
        return this.props.paymentMethods.length < 2 ? "d-none" : ""
    }

    render() {
        return (<div className={this.isRainforestBankTransferEnabled() ? "col-lg-7" : "col-lg-6"}>
            <Tabs
                defaultActiveKey={this.getActiveKey()}
                id="payment-tab-type"
                className={"mb-0 pb-0 justify-content-end " + this.getDisplayPaymentMethods()}
                onSelect={(selectedTab) => this.setState({ activeTabKey: selectedTab })}
            >
                {(this.props.paymentMethods.includes("credit-card") || this.props.variables.quote.objectType != "credit-memo") &&
                    <Tab
                        eventKey="credit-card"
                        style={{ color: "black" }}
                        title={this.props.intl.formatMessage(messages["credit_card_payment"])}
                    >
                        {this.state.activeTabKey === PAYMENT_TYPE.CREDIT_CARD &&
                            <div className={'span-active-black'}>
                                <div className={'mb-0 pl-4 pr-2 py-2 bg-light border'}>
                                    {
                                        //not handled for other external checkout integrations yet
                                        ['shopify', 'shopify-expert-app'].includes(this.props.variables.global.externalCheckoutIntegrationKey) ?
                                            <OnlinePayment
                                                countryCode={GlobalHelper.getCountryCodeFromCurrency(this.props.variables.quote.currency)}
                                                proposalHash={this.props.variables.hash}
                                                integrationKey={this.props.variables.global.externalCheckoutIntegrationKey}
                                                amount={String(this.props.getPaymentAmount())}
                                                currency={this.props.variables.quote.currency}
                                                paymentType={'external-checkout'}
                                                submitButton={<FormattedMessage
                                                    id="payment.confirm_proceed_to_checkout_btn"
                                                    defaultMessage="Proceed to checkout"
                                                />}
                                                submitButtonStyle={{
                                                    outlineColor: this.props.variables.global.buttonColor,
                                                    backgroundColor: this.props.variables.global.buttonColor,
                                                    borderColor: this.props.variables.global.buttonColor,
                                                    fontSize: '1rem',
                                                    fontWeight: 'bold',
                                                }}
                                                submitDisabled={parseFloat(this.props.getPaymentAmount()) <= 0 || this.props.loading}
                                                //this here
                                                contactId={this.props.contactId}
                                                variables={this.props.variables}
                                                isIntegrationConfigurationEnabled={this.props.isIntegrationConfigurationEnabled}
                                            /> :
                                            <>
                                                <TestModeAlert className="mt-2" isAccountPaymentGatewayTestMode={this.props.variables.global.paymentGatewayTestMode} />
                                                <OnlinePayment
                                                    countryCode={GlobalHelper.getCountryCodeFromCurrency(this.props.variables.quote.currency)}
                                                    publicKey={this.props.variables.global.paymentIntegrationPublicApiKey}
                                                    merchantId={this.props.variables.global.paymentIntegrationMerchantId}
                                                    integrationKey={this.props.variables.global.paymentIntegrationKey}
                                                    testMode={this.props.variables.global.paymentIntegrationTestMode}
                                                    amount={String(this.props.getPaymentAmount())}
                                                    submitDisabled={parseFloat(this.props.getPaymentAmount()) <= 0 || this.props.loading}
                                                    currency={this.props.variables.quote.currency}
                                                    onSubmit={this.props.handleSubmitNewCard}
                                                    submitButton={<FormattedMessage
                                                        id="payment.confirm_pay_now_btn"
                                                        defaultMessage="Pay Now"
                                                    />}
                                                    submitButtonStyle={{
                                                        outlineColor: this.props.variables.global.buttonColor,
                                                        backgroundColor: this.props.variables.global.buttonColor,
                                                        borderColor: this.props.variables.global.buttonColor,
                                                        fontSize: '1rem',
                                                        fontWeight: 'bold',
                                                    }}
                                                    forceSaveCard={this.props.section.attributes.content.forceSaveCard}
                                                    onPaymentIntentCompleted={this.props.handlePaymentIntentCompleted}
                                                    buildMetaData={this.props.buildMetaData}
                                                    proposalHash={this.props.proposalHash}
                                                    paymentAccount={this.props.paymentAccount}
                                                    isIntegrationConfigurationEnabled={this.props.isIntegrationConfigurationEnabled}
                                                    locationId={this.props.variables.quote.locationId}
                                                    acceptedCardBrands={this.props.acceptedCardBrands}
                                        />
                                            </>
                                    }
                                    {this.props.creditCardError}
                                </div>
                            </div>
                        }
                    </Tab>}
                {this.props.paymentMethods.includes("on-account") && this.props.variables && this.props.variables.quote.objectType == "credit-memo" && !this.props.isGolfContact &&
                    <Tab eventKey="on-account" title={this.props.intl.formatMessage(messages["my_account"])} className="span-active-black">
                        <div className={'row px-3 pt-2 bg-light span-active-black'}>
                            <div className="d-flex mt-2 mb-3 flex-column">
                                <div className="mb-3">
                                    <FormattedMessage
                                        id="proposal.checkout.pay_on_account_message"
                                        defaultMessage="By clicking on the following button, the total amount of the order will be added as a charge to {nameCheckout}’s credit account."
                                        values={{
                                            nameCheckout: this.props.firstName,
                                        }}
                                    />
                                </div>
                                <ActionButton
                                    loadingTimeout={30000}
                                    className="btn btn-lg span-active-black btn-primary px-4"
                                    style={{
                                        outlineColor: this.props.variables.global.buttonColor,
                                        backgroundColor: this.props.variables.global.buttonColor,
                                        borderColor: this.props.variables.global.buttonColor,
                                        fontWeight: 'bold',
                                    }}
                                    onClick={() => this.props.handleSubmit(true)}
                                >
                                    <FormattedMessage
                                        id="proposal.checkout.pay_on_account_btn"
                                        defaultMessage="Charge on account"
                                    />
                                </ActionButton>
                            </div>
                        </div>
                    </Tab>}
                {this.showBankTransferTab() &&
                    <Tab eventKey="bank-transfer" title={this.props.intl.formatMessage(messages["bank_transfer_payment"])}>
                        {this.state.activeTabKey === PAYMENT_TYPE.BANK_TRANSFER &&
                            <div className={'span-active-black'}>
                                <div className={'mb-0 pl-2 pr-2 py-2 bg-light border'}>
                                    <TestModeAlert className="mt-2" isAccountPaymentGatewayTestMode={this.props.variables.global.paymentGatewayTestMode} />
                                    <OnlinePayment
                                        countryCode={GlobalHelper.getCountryCodeFromCurrency(this.props.variables.quote.currency)}
                                        publicKey={this.props.variables.global.paymentIntegrationPublicApiKey}
                                        merchantId={this.props.variables.global.paymentIntegrationMerchantId}
                                        integrationKey={this.props.variables.global.paymentIntegrationKey}
                                        testMode={this.props.variables.global.paymentIntegrationTestMode}
                                        amount={String(this.props.getPaymentAmount())}
                                        submitDisabled={parseFloat(this.props.getPaymentAmount()) <= 0 || this.props.loading}
                                        currency={this.props.variables.quote.currency}
                                        onSubmit={this.props.handleSubmitNewCard}
                                        submitButton={<FormattedMessage
                                            id="payment.confirm_pay_now_btn"
                                            defaultMessage="Pay Now"
                                        />}
                                        submitButtonStyle={{
                                            outlineColor: this.props.variables.global.buttonColor,
                                            backgroundColor: this.props.variables.global.buttonColor,
                                            borderColor: this.props.variables.global.buttonColor,
                                            fontSize: '1rem',
                                            fontWeight: 'bold',
                                        }}
                                        forceSaveBankAccount={this.props.section.attributes.content.forceSaveBankAccount}
                                        onPaymentIntentCompleted={this.props.handlePaymentIntentCompleted}
                                        buildMetaData={this.props.buildMetaData}
                                        proposalHash={this.props.proposalHash}
                                        paymentAccount={this.props.paymentAccount}
                                        paymentType={PAYMENT_TYPE.BANK_TRANSFER}
                                        isIntegrationConfigurationEnabled={this.props.isIntegrationConfigurationEnabled}
                                        locationId={this.props.variables.quote.locationId}
                            />
                                </div>
                            </div>
                        }
                    </Tab>
                }
            </Tabs>
        </div>);
    }
}

export default injectIntl(PaymentTypeTabs);


// WEBPACK FOOTER //
// ./src/template/sections/content/checkout/paymentTypeTabs.component.jsx